
import { HedgingSettings, BulkHedgingSettings, BulkHedgingSettingsForAllLocations } from "./hedgingSettings";
import hedgingService from "./hedgingsService";
import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";
import trackApiCall from "features/saveIndicator/trackApiCall";
import HedgingConfiguration from "./hedgingConfiguration"

export class HedgingsLoaded extends Event {
    constructor(public hedgingSettings: HedgingSettings[]) {
        super(HedgingsLoaded.EventName);
    }

    public static EventName: string = "HEDGINGS_LOADED";
}

export class HedgingConfigurationLoaded extends Event {
    constructor(public configuration: HedgingConfiguration) {
        super(HedgingConfigurationLoaded.EventName);
    }

    public static EventName: string = "HEDGING_CONFIGURATION_LOADED";
}

export class HedgingSettingUpdated extends Event {
    constructor(public hedgingSetting: HedgingSettings) {
        super(HedgingSettingUpdated.EventName);
    }

    public static EventName: string = "HEDGING_SETTING_UPDATED";
}

export class BulkHedgingSettingUpdated extends Event {
    constructor(public bulkHedgingSetting: BulkHedgingSettings) {
        super(BulkHedgingSettingUpdated.EventName);
    }

    public static EventName: string = "BULK_HEDGING_SETTING_UPDATED";
}

export class BulkHedgingSettingAllLocationsUpdated extends Event {
    constructor(public bulkHedgingSettingsForAllLocations: BulkHedgingSettingsForAllLocations) {
        super(BulkHedgingSettingAllLocationsUpdated.EventName);
    }

    public static EventName: string = "BULK_HEDGING_SETTING_ALL_LOCATIONS_UPDATED";
}

export function loadHedgings(): ActionWithDispatch<HedgingsLoaded> {
    return function (dispatch) {
        return hedgingService
            .listHedgings()
            .then(hedgingSettings => dispatch(new HedgingsLoaded(hedgingSettings).toObject()));
    };
}

export function loadHedgingConfiguration(): ActionWithDispatch<HedgingConfigurationLoaded> {
    return function (dispatch) {
        return hedgingService
            .getHedgingConfiguration()
            .then(data => dispatch(new HedgingConfigurationLoaded(data).toObject()));
    };
}

export function updateHedgingSetting(newValue: HedgingSettings, oldValue: HedgingSettings): ActionWithDispatch<HedgingSettingUpdated, void> {
    return trackApiCall(dispatch => {
        dispatch(new HedgingSettingUpdated(newValue).toObject());
        return hedgingService
            .updateHedgingSetting(newValue)
            .catch((error) => {
                dispatch(new HedgingSettingUpdated(oldValue).toObject());
                throw error;
            });
    });
}

export function updateBulkHedgingSetting(newValue: BulkHedgingSettings, oldValue: BulkHedgingSettings): ActionWithDispatch<BulkHedgingSettingUpdated, void> {
    return trackApiCall(dispatch => {
        dispatch(new BulkHedgingSettingUpdated(newValue).toObject());
        return hedgingService
            .updateBulkHedgingSetting(newValue)
            .catch((error) => {
                dispatch(new BulkHedgingSettingUpdated(oldValue).toObject());
                throw error;
            });
    });
}

export function updateBulkHedgingSettingAllLocations(newValue: BulkHedgingSettingsForAllLocations, oldValue: BulkHedgingSettingsForAllLocations): ActionWithDispatch<BulkHedgingSettingAllLocationsUpdated, void> {
    return trackApiCall(dispatch => {
        dispatch(new BulkHedgingSettingAllLocationsUpdated(newValue).toObject());
        return hedgingService
            .updateBulkHedgingSettingAllLocations(newValue)
            .catch((error) => {
                dispatch(new BulkHedgingSettingAllLocationsUpdated(oldValue).toObject());
                throw error;
            });
    });
}